import { FC, useContext } from "react";
import NotificationDispatch, { showErrorNotification } from "../../context/notificationContext";
import useToggle from "../../hooks/useToggle";
import { useI18n } from "../../hooks/useTranslations";
import { ProcessingRequestStatus, ProcessingRequestStatuses } from "../../http/processingRequest/types";
import useProcessingRequestLabelApi from "../../http/processingRequestLabel/api";
import { PackagingAndLabelTypeLabel } from "../../http/processingRequestLabelsPackagings/types";
import useProcessingRequestPackagingApi from "../../http/processingRequestPackaging/api";
import SvgAdd from "../icons/Add";
import Button from "../ui/Button";
import Sidebar from "../ui/Sidebar";
import RequestLabelsAndPackagingsForm, { RequestLabelsAndPackagingsFormBody } from "./RequestLabelAndPackagingForm";

type CreateRequestLabelButtonProps = {
  requestId: number;
  requestStatus: ProcessingRequestStatus;
};

const CreateRequestLabelAndPackagingButton: FC<CreateRequestLabelButtonProps> = ({ requestId, requestStatus }) => {
  const { isOpen, open, close } = useToggle();
  const dispatch = useContext(NotificationDispatch);
  const { createRequestLabel } = useProcessingRequestLabelApi();
  const { createRequestPackaging } = useProcessingRequestPackagingApi();

  const i18n = useI18n();

  const isEditClosedRequest = requestStatus == ProcessingRequestStatuses.Closed;

  const onSubmit = async (formData: RequestLabelsAndPackagingsFormBody) => {
    try {
      const buildCommon = {
        requestId: requestId,
        expectedQuantity: isEditClosedRequest ? 0 : formData.quantity,
        usedQuantity: isEditClosedRequest ? formData.quantity : 0,
        unitCost: formData.unitCost,
      };
      if (formData.item.type === PackagingAndLabelTypeLabel) {
        await createRequestLabel({ ...buildCommon, label: formData.item });
      } else {
        await createRequestPackaging({ ...buildCommon, packaging: formData.item });
      }
      close();
    } catch (err) {
      dispatch(showErrorNotification(i18n, err));
    }
  };

  return (
    <>
      <Button buttonProps={{ onClick: open }} glyph={SvgAdd}></Button>
      <Sidebar isOpen={isOpen} onClose={close} title={i18n.t.common.newLabelOrPackaging}>
        <RequestLabelsAndPackagingsForm requestStatus={requestStatus} onSubmit={onSubmit} />
      </Sidebar>
    </>
  );
};

export default CreateRequestLabelAndPackagingButton;
